import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Alert from '../../common/Alert';
import { getServerTime, } from '../../../redux/Actions';

const TimeClock = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [currentTime, setCurrentTime] = useState('');

    useEffect(() => {
        let lastCheckTime = Date.now();
        const formatString = 'HH:mm:ss, dddd, D MMMM YYYY';
        const sessToken = sessionStorage.getItem("token");

        const updateClock = () => {
            const now = Date.now();

            // Skip check if tab was hidden (interval throttled)
            if (!document.hidden) {
                if (Math.abs(now - lastCheckTime - 1000) > 20000) {
                    console.warn('⚠️ System time change detected!');
                    if (sessToken != null) {
                        dispatch(getServerTime(sessToken))
                    }
                }
            }

            lastCheckTime = now;

            const currentMoment = moment(
                typeof window.getTime === 'function' ? window.getTime() : new Date()
            ).format(formatString);

            setCurrentTime(currentMoment);
        };

        const interval = setInterval(updateClock, 1000);

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                dispatch(getServerTime(sessToken))
                lastCheckTime = Date.now();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);



    return (
        <>
            <div>{currentTime}</div>
        </>
    );
};

export default TimeClock;
